import React from "react";

export default function EyeIcon() {
  return (
    <svg
      className="hover:text-darkblue"
      xmlns="http://www.w3.org/2000/svg"
      width="23"
      height="16"
      viewBox="0 0 23 16"
      fill="none"
    >
      <path
        d="M11.5 4.88867C9.77495 4.88867 8.38745 6.27617 8.38745 8.00117C8.38745 9.72617 9.77495 11.1137 11.5 11.1137C13.225 11.1137 14.6125 9.72617 14.6125 8.00117C14.6125 6.27617 13.225 4.88867 11.5 4.88867ZM11.5 9.42617C10.7125 9.42617 10.075 8.78867 10.075 8.00117C10.075 7.21367 10.7125 6.57617 11.5 6.57617C12.2875 6.57617 12.925 7.21367 12.925 8.00117C12.925 8.78867 12.2875 9.42617 11.5 9.42617Z"
        fill="currentColor"
      />
      <path
        d="M22.45 6.68789C20.3125 3.50039 17.35 0.275391 11.5 0.275391C5.65 0.275391 2.6875 3.50039 0.55 6.68789C0.025 7.47539 0.025 8.52539 0.55 9.31289C2.6875 12.4629 5.65 15.7254 11.5 15.7254C17.35 15.7254 20.3125 12.4629 22.45 9.31289C22.975 8.48789 22.975 7.47539 22.45 6.68789ZM21.0625 8.37539C18.325 12.3879 15.5875 14.0379 11.5 14.0379C7.4125 14.0379 4.675 12.3879 1.9375 8.37539C1.7875 8.15039 1.7875 7.85039 1.9375 7.62539C4.675 3.61289 7.4125 1.96289 11.5 1.96289C15.5875 1.96289 18.325 3.61289 21.0625 7.62539C21.175 7.85039 21.175 8.15039 21.0625 8.37539Z"
        fill="currentColor"
      />
    </svg>
  );
}
